import { render, staticRenderFns } from "./PricesLamitechModule.vue?vue&type=template&id=75d2dd94&scoped=true&"
import script from "./PricesLamitechModule.vue?vue&type=script&lang=js&"
export * from "./PricesLamitechModule.vue?vue&type=script&lang=js&"
import style0 from "./PricesLamitechModule.vue?vue&type=style&index=0&id=75d2dd94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d2dd94",
  null
  
)

export default component.exports